import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import auth from "../../auth/authHelper";
import classnames from "classnames";
import Loader from "../../Loader/Loader";
import ConfirmModal from "./ConfirmModal";
import EditModal from "./EditModal";
import styles from "./DataBox.scss";

var schema = {
  _id: undefined,
  first_name: "",
  last_name: "",
  email: "",
  password: "",
  root: false
};

export default class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: undefined,
      showConfirmModal: false,
      showEditModal: false,
      userData: {}
    };
  }

  updateTable = () => {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .get("/api/admin/users")
      .then(res => {
        this.setState({
          users: res.data
        });
      })
      .catch(e => console.log(e));
  };

  showConfirmModal = user => {
    this.setState({ showConfirmModal: true, userData: user });
  };

  hideConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  showEditModal = user => {
    this.setState({ showEditModal: true, userData: user });
  };

  hideEditModal = () => {
    this.setState({ showEditModal: false });
  };

  deleteUser(user) {
    var id = auth.isAuthenticated().user._id;
    if (id === user._id) {
      console.log("can not delete signed in user");
    } else {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwt"
      );
      axios
        .post("/api/admin/removeuser", user)
        .then(res => {
          this.updateTable();
        })
        .catch(e => console.log(e));
    }
  }

  updateOrAddUser(user) {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/updateoradduser", user)
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
    schema = {
      _id: undefined,
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      root: false
    };
  }

  componentDidMount = () => {
    this.updateTable();
  };

  render() {
    if (!this.state.users) {
      return <Loader />;
    } else {
      return (
        <div className={styles.dataBox}>
          <ConfirmModal
            show={this.state.showConfirmModal}
            handleClose={this.hideConfirmModal}
            data={this.state.userData}
            deleteData={this.deleteUser}
            updateTable={this.updateTable}
            type={"users"}
          />
          <EditModal
            show={this.state.showEditModal}
            handleClose={this.hideEditModal}
            data={this.state.userData}
            updateOrAdd={this.updateOrAddUser}
            updateTable={this.updateTable}
            type={"users"}
          />
          <button
            className={classnames("btn btn-info", styles.modalButtons)}
            onClick={() => this.showEditModal(schema)}
          >
            <FontAwesomeIcon className={styles.cursor} icon={faPlus} />
          </button>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">S/N</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Root</th>
                <th scope="col" className="textCenter">
                  Edit
                </th>
                <th scope="col" className="textCenter">
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.users.map((user, i) => (
                <tr key={i}>
                  <td>{i}</td>
                  <td>{user.first_name}</td>
                  <td>{user.last_name}</td>
                  <td>{user.email}</td>
                  <td>{String(user.root)}</td>
                  <td className="textCenter">
                    <FontAwesomeIcon
                      className={styles.cursor}
                      onClick={() => this.showEditModal(user)}
                      style={{ color: "#323643" }}
                      icon={faEdit}
                    />
                  </td>
                  <td className="textCenter">
                    <FontAwesomeIcon
                      className={styles.cursor}
                      onClick={() => this.showConfirmModal(user)}
                      style={{ color: "#323643" }}
                      icon={faTrash}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/Users.js